var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-expand-md navbar-dark bg-dark static-top"},[_c('div',{staticClass:"container-fluid"},[_c('router-link',{attrs:{"to":"/"}},[_c('a',{staticClass:"navbar-brand mr-3"},[_vm._v("Marvin")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }